module.exports = __webpack_public_path__ + "static/img/img_form_2_en.e50aa71b.png";